export const POLICY_DELIVERY_START = 'POLICY_DELIVERY_START';
export const POLICY_DELIVERY_SUCCESS = 'POLICY_DELIVERY_SUCCESS';
export const POLICY_DELIVERY_FAILED = 'POLICY_DELIVERY_FAILED';
export const POLICY_DELIVERY_DOWNLOAD_START = 'POLICY_DELIVERY_DOWNLOAD_START';
export const POLICY_DELIVERY_DOWNLOAD_SUCCESS = 'POLICY_DELIVERY_DOWNLOAD_SUCCESS';
export const POLICY_DELIVERY_DOWNLOAD_FAILED = 'POLICY_DELIVERY_DOWNLOAD_FAILED';

export interface PolicyDeliveryResponse {
  policyNumber: string;
  records: {
    referenceNumber: string;
    transactionDate: string;
    emailAddress: string;
    ccEmailAddress?: string;
    firstName: string;
    lastName: string;
    startDate: string;
    issuedBy: string;
    endorsedBy: string;
    lang: string;
    status: string;
    emailRef: string;
  }[];
}
export interface PolicyDeliveryStore {
  deliveryFetched?: boolean;
  deliveryError?: unknown;
  confirmationFetching?: boolean;
  confirmationError?: unknown;
  reqPolRefNumber?: string;
  data?: PolicyDeliveryResponse[];
  confirmationData?: Record<string, Blob>;
}
